import { render, staticRenderFns } from "./MembershipHistoryTable.vue?vue&type=template&id=137cc4d3&scoped=true&"
import script from "./MembershipHistoryTable.vue?vue&type=script&lang=js&"
export * from "./MembershipHistoryTable.vue?vue&type=script&lang=js&"
import style0 from "./MembershipHistoryTable.vue?vue&type=style&index=0&id=137cc4d3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "137cc4d3",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VChip,VIcon,VSimpleTable})
